export class CompanyStorage {
  public code: string | undefined = undefined;
  public quantity = 0;
  public parcelTypesQuantity: Record<string, number> = {};
}
